import type Pusher from "pusher-js";

export class Subscriber {
  private readonly pusher: Pusher | undefined;

  constructor(pusher?: Pusher) {
    this.pusher = pusher;
  }

  session_id() {
    if (!this.pusher) {
      return null;
    }
    return this.pusher.sessionID.toString();
  }

  subscribe<T>(
    channel_suffix: string,
    event: string,
    callback: (data: T) => void,
  ) {
    if (!this.pusher) {
      return;
    }
    const channel = this.pusher.subscribe(`private-${channel_suffix}`);
    channel.bind(event, callback);
  }
}
